import { render, staticRenderFns } from "./classRank.vue?vue&type=template&id=614c0142&"
import script from "./classRank.vue?vue&type=script&lang=js&"
export * from "./classRank.vue?vue&type=script&lang=js&"
import style0 from "./classRank.vue?vue&type=style&index=0&id=614c0142&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports